import { createReducer, on } from '@ngrx/store';
import {
  AdminProjectTemplateListPageOpenedAction,
  AdminProjectTemplateListLoaded,
  AdminProjectTemplateApiErrored,
  EditAdminProjectTemplatePageOpenedAction,
  AdminProjectTemplateLoaded,
  AdminProjectTemplateUpdated,
  EditAdminProjectTemplateSubmittedAction,
  AddAdminProjectModalDestroyed,
  NewAdminProjectTemplateSubmittedAction,
  AdminProjectTemplateCreatedAction,
} from './admin-project-template.actions';
import { AdminProjectTemplateApiError } from './admin-project-template.errors';
import { AdminProjectTemplate } from './models/admin-project-template.model';

export interface AdminProjectTemplateState {
  templates: AdminProjectTemplate[];
  currentTemplate: AdminProjectTemplate;
  apiError: AdminProjectTemplateApiError;
  requestInProgress: boolean;
}

export const initialState: AdminProjectTemplateState = {
  templates: null,
  currentTemplate: null,
  apiError: null,
  requestInProgress: false,
};

export const adminProjectTemplateReducer = createReducer(
  initialState,
  on(AdminProjectTemplateListPageOpenedAction, (state) => ({
    ...state,
    apiError: null,
  })),
  on(AdminProjectTemplateListLoaded, (state, { templates }) => ({
    ...state,
    templates,
  })),
  on(EditAdminProjectTemplatePageOpenedAction, (state) => ({
    ...state,
    currentTemplate: null,
    apiError: null,
  })),
  on(AdminProjectTemplateLoaded, (state, { template }) => ({
    ...state,
    currentTemplate: template,
  })),
  on(NewAdminProjectTemplateSubmittedAction, (state) => ({
    ...state,
    apiError: null,
    requestInProgress: true,
  })),
  on(AdminProjectTemplateCreatedAction, (state) => ({
    ...state,
    requestInProgress: false,
  })),
  on(EditAdminProjectTemplateSubmittedAction, (state) => ({
    ...state,
    apiError: null,
    requestInProgress: true,
  })),
  on(AdminProjectTemplateUpdated, (state, { template }) => ({
    ...state,
    currentTemplate: template,
    requestInProgress: false,
  })),
  on(AdminProjectTemplateApiErrored, (state, { error }) => ({
    ...state,
    apiError: error,
    requestInProgress: false,
  })),
  on(AddAdminProjectModalDestroyed, (state) => ({
    ...state,
    apiError: null,
  })),
);
